export default "__VITE_ASSET__Cbyp_PtL__"